module.exports = __webpack_public_path__ + "img/new-center-buy-icon.3563d508.png";